import { InstructionsStepCtrl } from './instructions.controller';

export const InstructionsStepComponent = {
  controller: InstructionsStepCtrl,
  bindings: {
    nextStep: '&',
  },
  template: require('./instructions.html'),
};
